import rootReducer from ".";
import { configureStore } from "@reduxjs/toolkit";

const rootReducerWithReset = (state, action) => {
	switch (action.type) {
		case "RESET":
			const { security, global } = state;
			state = { security, global };
			break;
		case "SET_FROM_SESSION":
			state = action.payload;
			break;
		default:
			break;
	}
	return rootReducer(state, action);
};

const store = configureStore({
	reducer: rootReducerWithReset,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
	devTools: process.env.NODE_ENV !== "production",
});

export default store;
